import { useTranslation } from '../../../../../services/translation/hooks/useTranslation';
import { DataGridDialogWithDownload } from '../../../../commonUI/DataGridDialogWithDownload';
import { createExportFileName } from '../../../../dataGridTables/utils/createExportFileName';
import { ClusterReportTable } from './ClusterReportTable';
import { TableViewData } from './types';

type Props = {
  open: boolean;
  onClose: () => void;
  customerId: string;
  data: TableViewData[];
  isLoading: boolean;
};

export const TableViewDialog = ({
  open,
  onClose,
  customerId,
  data,
  isLoading,
}: Props) => {
  const { t } = useTranslation();

  return (
    <DataGridDialogWithDownload
      open={open}
      onClose={onClose}
      title={t('Cluster Count')}
      GridComponent={({ dataGridApiRef }) => (
        <ClusterReportTable
          data={data}
          isLoading={isLoading}
          customerId={customerId}
          dataGridApiRef={dataGridApiRef}
        />
      )}
      exportFileName={createExportFileName('Cluster Count', t)}
    />
  );
};
